<template>
  <div class="travels-view">
    <HubTravels
      name="travels"
      :overview="overview"
      :users="users"
      :user="user"
      v-if="loaded"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import HubTravels from '@blocks/hubs/HubTravels'
import updateBreadcrumb from '@mixins/updateBreadcrumb'

export default {
  name: 'TravelsView',
  mixins: [ updateBreadcrumb ],
  components: {
    HubTravels
  },
  data () {
    return {
      loaded: false
    }
  },
  computed: {
    ...mapGetters({
      users: 'travels/getRequestUsers',
      overview: 'travels/getOverview',
      user: 'travels/getUser'
    })
  },
  created () {
    this.fetchGetPage({ service: 'travels' }).then(() => {
      this.loaded = true
    })
  },
  methods: {
    ...mapActions({
      'fetchGetPage': 'page/fetchGetPage'
    })
  }
}
</script>

<style lang="scss">
  .travels-details{
    &__select{
      @include icon(icons("chevron-down"));
      position: relative;
      max-width: 22rem;
      &:before{
        position: absolute;
        right: 1.5rem;
        top: 50%;
        transform: translateY(-50%);
        color: colors('primary');
        display: block;
        width: 2rem;
        height: 2rem;
      }
      select{
        margin-bottom: 0;
        padding-right: 5rem;
        color: #404040;
        background-color: colors('foreground');
        border-color: colors('border');
      }
    }
  }
</style>
